module.exports = {
      id: "circle_chev-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#circle_chev-usage",
      toString: function () {
        return this.url;
      }
    }